<script>
import {
  findConpany,
  findThisConpany,
  selectThisRecord,
  ReAdd,
  updateRe,
  getFunnel,
  SaUFunnel,
  getfamily,
  savefollow,
  getfollow,
  ChaChong,
  getUserId
} from "../../../../api/crm";
import { searchUserListExclude } from "../../../../api/auth/user";
import { getDict } from "../../../../api/dict";
import moment from "moment";
import chinaCitys from "@/plugins/ChinaCitys.json";
export default {
  components: {},

  data() {
    return {
      tabList: [],
      tabKey: "funnel",
      isLoading: false,
      errorOptions: {
        company: false
      },
      familyRecords: [],
      followArr: [],
      // ruleForm: {
      //   reportTime: "",
      //   reportMan: "",
      //   saleman: "",
      //   reportManId: "",
      //   salemanId: "",
      //   company: "",
      //   ssq: "",
      //   companyAddress: "",
      //   linkman: "",
      //   linkmanNum: "",
      //   policymaker: "",
      //   policymakerNum: "",
      //   customerDemand: "",
      //   informationSources: "",
      //   originalModel: "",
      //   estimatedPurchaseTime: "",
      //   isorder: "",
      //   note: "",
      //   state: ""
      // },
      options1: [],
      options2: [],
      isSystemLogLoading: false,
      list: [],
      dialogFormVisible: false,
      options: [],
      value: [],
      list: [],
      loading: false,
      selectedProvince: {},
      selectedCity: {},
      companyDetail: {},
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      fileList: [],
      fileList1: [],
      Ttitle: "",
      CCresult: [],
      zsArray: [],
      dialogTableVisible: false,
      dialogyc: false,
      allowTJ: false,
      fileList2: [],
      china: chinaCitys,
      formLabelWidth: "120px",
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ["10", "20", "30", "40", "50"],
        showSizeChanger: true
      },
      ruleForm: {
        id: this.$route.query.id,
        reportTime: "",
        reportMan: "",
        saleman: "",
        reportManId: "",
        salemanId: "",
        company: "",
        ssq: "",
        companyAddress: "",
        failReason: "",
        linkman: "",
        linkmanNum: "",
        zz: "",
        policymaker: "",
        policymakerNum: "",
        customerDemand: "",
        informationSources: "",
        originalModel: "",
        estimatedPurchaseTime: "",
        customerBelong: "",
        associatedRecordsId: "",
        isorder: "",
        isover: "",
        note: "",
        state: "",
        ycyy: "",
        cdjx: "",
        files: []
      },
      follow: {
        fillTime: "",
        saleman: "",
        salemanId: "",
        trackSituation: "",
        nextVisitTime: "",
        nextVisitGoal: "",
        recordId: "",
        files: []
      },
      funnel: {
        id: "",
        industryClassification: "",
        businessType: "",
        projectname: "",
        customerUnit: "",
        salesman: "",
        salesmanId: "",
        startTime: "",
        budgetedAmount: "",
        currentStage: "",
        winPercent: "",
        expectedOutput: "",
        contractAmount: "",
        customerLeadDepartment: "",
        relevantContact: "",
        customerStakeholders: "",
        keyman: "",
        demandContent: "",
        currentProgress: "",
        nextVisitTime: "",
        visitContent: "",
        competitor: "",
        cooperativePartner: "",
        determine: "",
        failureReason: "",
        recordId: "",
        delFileId: []
      },
      rules: {},
      pageNo: 1,
      limit: 10,
      options3: [],
      options4: [],
      options5: [],
      options6: [],
      options7: [],
      options8: [],
      ycyy: "",
      total: 0,
      zzid: "",
      youid:"",
      formLabelWidth: "120px",
      companyList: [],
      userList: [],
      reuserList: [],
      isCompanyLoading: false,
      allA: {},
      srcList: [],
      srcList1: [],
      p: "",
      c: "",
      area: "",
      zhen: "",
      cxzhen: [
        "浒山街道",
        "白沙路街道",
        "古塘街道",
        "宗汉街道",
        "坎墩街道",
        "匡堰镇",
        "逍林镇",
        "龙山镇",
        "掌起镇",
        "观海卫镇",
        "附海镇",
        "桥头镇",
        "胜山镇",
        "横河镇",
        "长河镇",
        "崇寿镇",
        "新浦镇",
        "周巷镇",
        "庵东镇",
        "杭州湾新区"
      ],
      authorities: []
    };
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang: {
      immediate: true,
      handler() {
        this.translate()
      }
    }
  },
  async created() {
    const a = JSON.parse(sessionStorage.getItem("authorities"));
    if (a?.length) {
      this.authorities = a;
    } else {
      this.authorities = this.getAuthorities(this.$route.path);
    }
    const b = await getUserId();
    if (b) {
      this.zzid = b.data.zzid;
      this.youid = b.data.id;
    }
    await this.slr();
    await this.gF();
  },
  methods: {
    async translate() {
      this.tabList = [
        {
          key: "funnel",
          tab: this.$t('recordDetail.funnel'),
          sort: 1
        },
        {
          key: "uphistory",
          tab: this.$t('common.record'),
          sort: 2
        },
        {
          key: "gzRecord",
          tab: this.$t('recordDetail.followRecord'),
          sort: 2
        }
      ]
      this.options1 = [
        {
          value: 0,
          label: this.$t('recordDetail.nOrdered')
        },
        {
          value: 1,
          label: this.$t('recordDetail.ordered')
        }
      ]
      this.options2 = [
        {
          value: 1,
          label: this.$t('report46.unaudited')
        },
        {
          value: 2,
          label: this.$t('recordDetail.reportValid')
        },
        {
          value: 3,
          label: this.$t('recordDetail.reportInvalid')
        }
      ]
      this.rules = {
        reportTime: [
          {
            type: "date",
            required: true,
            message: this.$t('device.selectDate'),
            trigger: "blur"
          }
        ],
        reportMan: [
          { required: true, message: this.$t('recordDetail.er'), trigger: "blur" }
        ],
        saleman: [{ required: true, message: this.$t('recordDetail.es'), trigger: "blur" }],
        company: [
          { required: true, message: this.$t('messages.company_empty'), trigger: "blur" }
        ],
        ssq: [{ required: true, message: this.$t('recordDetail.sa'), trigger: "blur" }],
        linkman: [{ required: true, message: this.$t('recordDetail.el'), trigger: "blur" }],
        linkmanNum: [
          { required: true, message: this.$t('recordDetail.eln'), trigger: "blur" }
        ],
        policymaker: [
          { required: true, message: this.$t('recordDetail.ek'), trigger: "blur" }
        ],
        policymakerNum: [
          { required: true, message: this.$t('recordDetail.ekn'), trigger: "blur" }
        ],
        customerDemand: [
          { required: true, message: this.$t('recordDetail.ecd'), trigger: "blur" }
        ],
        originalModel: [
          { required: true, message: this.$t('recordDetail.ecd'), trigger: "blur" }
        ],
        estimatedPurchaseTime: [
          { required: true, message: this.$t('recordDetail.eept'), trigger: "blur" }
        ],
        informationSources: [
          { required: true, message: this.$t('recordDetail.eept'), trigger: "change" }
        ],
        companyAddress: [
          { required: true, message: this.$t('messages.address_empty'), trigger: "blur" }
        ]
        ,
        customerBelong: [
          { required: true, message: this.$t('messages.ecb'), trigger: "blur" }
        ]
      }
      this.options3 = await this.getOption("industryClassification");
      this.options4 = await this.getOption("businessType");
      this.options5 = await this.getOption("currentStage");
      this.options6 = await this.getOption("winPercent");
      this.options7 = await this.getOption("determine");
      this.options8 = await this.getOption("informationSources");
      this.onTabChange(this.tabKey)
      this.getf()
    },
    closeTable() {
      this.zsArray = [];
      this.allowTJ = false;
    },
    async getOption(a) {
      const lang = this.lang === 'en' ? 'en-US' : 'zh-CN'
      const result = await getDict(lang, a);
      if (result.code == 0) {
        return result.data.content;
      }
    },
    async slr() {
      const result = await selectThisRecord(this.ruleForm.id);
      if (result && result.code == 0) {
        this.ruleForm = result.data;
        const a = this.ruleForm.ssq.split("/");

        if (a.length == "3") {
          this.p = a[0];
          this.c = a[1];
          this.area = a[2];
        } else if (a.length == "4") {
          this.p = a[0];
          this.c = a[1];
          this.area = a[2];
          this.zhen = a[3];
        }
        if (this.ruleForm.files && this.ruleForm.files.length > 0) {
          this.ruleForm.files.forEach(e => {
            this.srcList.push(e.path);
          });
        }
      }
    },
    async gF() {
      const result = await getFunnel(this.ruleForm.associatedRecordsId);
      if (result.code == 0) {
        if (result.data && result.data != null) {
          this.funnel = result.data;
          this.funnel.delFileId = [];
        } else if (result.data == null) {
          this.funnel.customerUnit = this.ruleForm.company;
          this.funnel.salesman = this.ruleForm.saleman;
          this.funnel.salesmanId = this.ruleForm.salemanId;
          if (this.funnel.files && this.funnel.files.length > 0) {
            this.funnel.files.forEach(e => {
              this.srcList1.push(e.path);
            });
          }
        }
      }
    },
    goBack() {
      this.$router.back();
    },
    async zhaoren(e) {
      const result = await searchUserListExclude(1, 15, {
        filter: [],
        query: [{ field: "realName", value: e }],
        sort: [{ field: "updatedAt", value: "DESC" }]
      });
      this.userList = result.data.records;
    },
    async zhaoren1(e) {
      const result = await searchUserListExclude(1, 15, {
        filter: [],
        query: [{ field: "realName", value: e }],
        sort: [{ field: "updatedAt", value: "DESC" }]
      });
      this.reuserList = result.data.records;
    },

    validate(option) {
      this.errorOptions[option] = !this.form[option]?.trim();
      this.$forceUpdate();
      return this.errorOptions[option];
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          alert("submit!");
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    hm(a) {
      a.show = true;
      this.$forceUpdate();
    },
    ml(a) {
      a.show = false;
      this.$forceUpdate();
    },
    async onTabChange(key) {
      this.tabKey = key;
      // this.selectedUserList = this[this.tabKey]
      switch (key) {
        case "funnel":
          this.param = this.$t('recordDetail.funnel');
          break;
        case "uphistory":
          this.param = this.$t('common.record');
          await this.getf();
          break;
        case "gzRecord":
          this.param = this.$t('recordDetail.followRecord');
          await this.getAllFollow();
          break;
        default:
          break;
      }
    },
    async getf() {
      const result = await getfamily(this.ruleForm.associatedRecordsId);
      if (result.code == 0) {
        this.familyRecords = result.data.map(e => {
          e.description = false;
          if (e.state == "1") {
            e.is = this.$t('report46.unaudited');
          } else if (e.state == "2") {
            e.is = this.$t('recordDetail.reportValid');
          } else if (e.state == "3") {
            e.is = this.$t('recordDetail.reportInvalid');
          }
          return e;
        });
      } else {
        this.$notify.error({
          title: this.$t('messages.error'),
          message: result.message
        });
      }
    },
    showFileModal() {
      this.$refs.InputFileDOm.click();
    },
    showFileModal1() {
      this.$refs.InputFileDOm1.click();
    },
    showFileModal2() {
      this.$refs.InputFileDOm2.click();
    },
    onBeforeUpload(file) {
      let acceptTypes;
      acceptTypes = [
        "image/jpg",
        "image/jpeg",
        "image/png",
        "video/mp4",
        "video/webm"
      ];
      if (file.size > 1024 * 1024 * 500) {
        // 文件大于 30M 时取消上传
        ElNotification({
          type: "error",
          message: this.$t('messages.lessThan500MB')
        });
        return false;
      }
      if (!acceptTypes.includes(file.type)) {
        // 继续上传
        ElNotification({
          type: "error",
          message: this.$t('messages.rightFile')
        });
        return false; // 停止上传
      }
      return true;
    },
    onBeforeUpload(file) {
      let acceptTypes;
      acceptTypes = [
        "image/jpg",
        "image/jpeg",
        "image/png",
        "video/mp4",
        "video/webm"
      ];
      if (file.size > 1024 * 1024 * 500) {
        // 文件大于 30M 时取消上传
        ElNotification({
          type: "error",
          message: this.$t('messages.lessThan500MB')
        });
        return false;
      }
      if (!acceptTypes.includes(file.type)) {
        // 继续上传
        ElNotification({
          type: "error",
          message: this.$t('messages.rightFile')
        });
        return false; // 停止上传
      }
      return true;
    },
    hadnleFileCHnage(e, a) {
      let i;
      for (i = 0; i < e.target.files.length; i++) {
        if (!this.onBeforeUpload(e.target.files[i])) {
          break;
        }
      }
      if (i == e.target.files.length) {
        this.fileList = this.fileList.concat(Array.from(e.target.files));
      }
    },
    hadnleFileCHnage1(e, a) {
      let i;
      for (i = 0; i < e.target.files.length; i++) {
        if (!this.onBeforeUpload(e.target.files[i])) {
          break;
        }
      }
      if (i == e.target.files.length) {
        this.fileList1 = this.fileList1.concat(Array.from(e.target.files));
      }
    },
    hadnleFileCHnage2(e, a) {
      let i;
      for (i = 0; i < e.target.files.length; i++) {
        if (!this.onBeforeUpload(e.target.files[i])) {
          break;
        }
      }
      if (i == e.target.files.length) {
        this.fileList2 = this.fileList2.concat(Array.from(e.target.files));
      }
    },
    rF(i) {
      this.$Mconfirm(this.$t('messages.ctrd'), this.$t('messages.hint'), {
        confirmButtonText: this.$t('common.okText'),
        cancelButtonText: this.$t('common.cancelText'),
        type: "warning"
      })
        .then(() => {
          const arr = [...this.fileList];
          arr.splice(i, 1);
          this.fileList = arr;
          this.$forceUpdate();
          this.$EM({
            type: "success",
            message: this.$t('messages.rs')
          });
          return true;
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t('messages.cr')
          });
        });
    },
    rF1(i) {
      this.$Mconfirm(this.$t('messages.ctrd'), this.$t('messages.hint'), {
        confirmButtonText: this.$t('common.okText'),
        cancelButtonText: this.$t('common.cancelText'),
        type: "warning"
      })
        .then(() => {
          const arr = [...this.fileList1];
          arr.splice(i, 1);
          this.fileList1 = arr;
          this.$forceUpdate();
          this.$EM({
            type: "success",
            message: this.$t('messages.rs')
          });
          return true;
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t('messages.cr')
          });
        });
    },
    rF2(i) {
      this.$Mconfirm(this.$t('messages.ctrd'), this.$t('messages.hint'), {
        confirmButtonText: this.$t('common.okText'),
        cancelButtonText: this.$t('common.cancelText'),
        type: "warning"
      })
        .then(() => {
          const arr = [...this.fileList2];
          arr.splice(i, 1);
          this.fileList2 = arr;
          this.$forceUpdate();
          this.$EM({
            type: "success",
            message: this.$t('messages.rs')
          });
          return true;
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t('messages.cr')
          });
        });
    },
    remoteMethod(e) {
      if (e.length >= 2) {
        this.ruleForm.company = e;
        this.loading = true;
        this.findC();
        this.options = this.companyList;
        this.loading = false;
      }
    },
    remoteMethod1(e) {
      if (e.length >= 1) {
        this.loading = true;
        this.zhaoren(e);
        this.options = this.userList;
        this.loading = false;
      }
    },
    remoteMethod2(e) {
      if (e.length >= 1) {
        this.loading = true;
        this.zhaoren1(e);
        this.options = this.reuserList;
        this.loading = false;
      }
    },

    selectSheng() {
      if (this.p != this.selectedProvince.name) {
        this.c = "";
        this.area = "";
        this.ruleForm.ssq = "";
      }
      this.selectedProvince = this.china.find(item => {
        if (item.province == this.p) {
          return item;
        }
      });
      this.selectedCity = {};
    },

    selectCity() {
      if (this.c != this.selectedCity.city) {
        this.area = "";
        this.ruleForm.ssq = "";
      }
      this.selectedCity = this.selectedProvince.citys.find(item => {
        if (item.city == this.c) {
          return item;
        }
      });
    },

    selectArea() {
      this.ruleForm.ssq = this.p + "/" + this.c + "/" + this.area;
    },

    selectzhen() {
      this.ruleForm.ssq = this.ruleForm.ssq + "/" + this.zhen;
    },

    async clickThis() {
      const result = await findThisConpany(this.ruleForm.company);
      if (result.code == 0 && result.data) {
        this.companyDetail = result.data;
        this.ruleForm.companyAddress = this.companyDetail.regLocation;
        this.p = this.companyDetail.province;
        if (this.p != "" && this.p != null) {
          await this.selectSheng();
        }
        if (this.companyDetail.city == "市辖区") {
          this.c = this.companyDetail.province;
        } else {
          this.c = this.companyDetail.city;
        }
        if (this.c != "" && this.c != null) {
          await this.selectCity();
        }
        this.area = this.companyDetail.district;
        if (this.area != "" && this.area != null) {
          await this.selectArea();
        }
      } else {
        this.$notify.error({
          title: this.$t('messages.error'),
          message: this.$t('messages.spk')
        });
      }
    },
    async clickThis1(a) {
      this.ruleForm.salemanId = a.id;
    },
    async clickThis2(a) {
      this.ruleForm.reportManId = a.id;
      this.ruleForm.zzid = a.organizationId;
      this.ruleForm.zz = a.organization;
    },
    async findC() {
      const result = await findConpany("1", "20", this.ruleForm.company);
      if (result && result.code == 0) {
        this.companyList = result.data.records;
      }
    },
    async allowAdd(a, b) {
      let flag = true;
      this.$refs[a].validate(async valid => {
        flag && (flag = valid);
      });
      this.$refs[b].validate(async valid => {
        flag && (flag = valid);
      });
      if (this.ruleForm.state == "3") {
        this.$message.info(this.$t('recordDetail.recommit'));
        return false;
      }
      if (flag) {
        const formdata = new FormData();
        if (
          this.ruleForm.company != "" &&
          this.ruleForm.company != null &&
          this.ruleForm.linkmanNum != "" &&
          this.ruleForm.linkmanNum != null &&
          this.ruleForm.policymakerNum != "" &&
          this.ruleForm.policymakerNum != null
        ) {
          formdata.append("id", this.ruleForm.associatedRecordsId);
          formdata.append("company", this.ruleForm.company);
          formdata.append("saleman", this.ruleForm.saleman);
          formdata.append("linkmanNum", this.ruleForm.linkmanNum);
          formdata.append("policymakerNum", this.ruleForm.policymakerNum);
          const result = await ChaChong(formdata);
          this.CCresult = result.data;
          this.ccMes = result.message;
          if (this.CCresult == 1) {
            if (this.ruleForm.state == "2") {
              this.dialogyc = true;
            } else {
              this.$message.success(this.ccMes);
              const formdata = new FormData();
              formdata.append(
                "reportTime",
                moment(+new Date()).format("YYYY-MM-DD HH:mm:ss")
              );
              formdata.append("reportMan", this.ruleForm.reportMan);
              formdata.append("saleman", this.ruleForm.saleman);
              formdata.append("company", this.ruleForm.company);
              formdata.append("reportManId", this.ruleForm.reportManId);
              formdata.append("salemanId", this.ruleForm.salemanId);
              formdata.append("zz", this.ruleForm.zz);
              formdata.append("ssq", this.ruleForm.ssq);
              formdata.append("companyAddress", this.ruleForm.companyAddress);
              formdata.append("linkman", this.ruleForm.linkman);
              formdata.append("linkmanNum", this.ruleForm.linkmanNum);
              formdata.append("policymaker", this.ruleForm.policymaker);
              formdata.append("policymakerNum", this.ruleForm.policymakerNum);
              formdata.append("customerBelong", this.ruleForm.customerBelong);
              formdata.append("customerDemand", this.ruleForm.customerDemand);
              formdata.append(
                "informationSources",
                this.ruleForm.informationSources
              );
              formdata.append("originalModel", this.ruleForm.originalModel);

              if (
                this.ruleForm.estimatedPurchaseTime &&
                typeof this.ruleForm.estimatedPurchaseTime === "string"
              ) {
                formdata.append(
                  "estimatedPurchaseTime",
                  this.ruleForm.estimatedPurchaseTime
                );
              } else if (
                this.ruleForm.estimatedPurchaseTime &&
                this.ruleForm.estimatedPurchaseTime instanceof Date
              ) {
                formdata.append(
                  "estimatedPurchaseTime",
                  moment(+this.ruleForm.estimatedPurchaseTime).format(
                    "YYYY-MM-DD HH:mm:ss"
                  )
                );
              } else {
                formdata.append(
                  "estimatedPurchaseTime",
                  this.ruleForm.estimatedPurchaseTime
                );
              }
              formdata.append("isorder", this.ruleForm.isorder);
              formdata.append("isover", this.ruleForm.isover);
              formdata.append("note", this.ruleForm.note);
              formdata.append("zzid", this.ruleForm.zzid);
              formdata.append("cdjx", this.ruleForm.cdjx);
              formdata.append(
                "associatedRecordsId",
                this.ruleForm.associatedRecordsId
              );
              formdata.append("state", this.ruleForm.state);
              formdata.append("oldFiles", this.srcList);
              this.fileList.map(file => {
                formdata.append("files", file);
              });
              const result = await ReAdd(formdata);
              if (result.code == 0) {
                this.$notify.success({
                  title: this.$t('messages.success'),
                  message: result.message
                });
                this.$router.back();
              } else {
                this.$notify.error({
                  title: this.$t('messages.error'),
                  message: result.message
                });
              }
            }
          } else if (this.CCresult == 2) {
            this.$message.info(this.ccMes);
          } else if (!Array.isArray(this.CCresult)) {
            if ("ygkcus" in this.CCresult) {
              for (let i in this.CCresult["ygkcus"]) {
                this.CCresult["ygkcus"][i].salemandd = "";
                // if(Array.isArray(this.CCresult['ygkcus'][i].salesmen)){
                //   for(let item in this.CCresult['ygkcus'][i].salesmen){
                //     this.CCresult['ygkcus'][i].salemandd = this.CCresult['ygkcus'][i].salesmen[item]+ ' '
                //   }

                // }
                this.zsArray.push({
                  reportTime: this.CCresult["ygkcus"][i].createdAt,
                  company: this.CCresult["ygkcus"][i].company,
                  saleman: this.CCresult["ygkcus"][i].salesmen
                });
              }
            } else {
            }
            if ("list204" in this.CCresult) {
              for (let ii in this.CCresult["list204"]) {
                this.zsArray.push(this.CCresult["list204"][ii]);
              }
            } else {
            }
            this.Ttitle = this.$t('messages.oldCustomerInfo');
            this.allowTJ = true;
            this.dialogTableVisible = true;
          } else if (Array.isArray(this.CCresult)) {
            this.zsArray = this.CCresult;
            this.Ttitle = this.$t('messages.reportedInfo');
            this.allowTJ = true;
            this.dialogTableVisible = true;
          }
        } else {
          this.$message.info(this.$t('messages.completeForm'));
        }
      } else {
        return false;
      }
    },
    delPic(i) {
      this.ruleForm.files.splice(i, 1);
      this.srcList.splice(i, 1);
    },
    delPic1(i) {
      this.funnel.delFileId.push(this.funnel.files[i].id);
      this.funnel.files.splice(i, 1);
    },
    async adminUp() {
      const formdata = new FormData();

      formdata.append("id", this.ruleForm.id);
      formdata.append("isorder", this.ruleForm.isorder);
      formdata.append("company", this.ruleForm.company);
      formdata.append("reportMan", this.ruleForm.reportMan);
      formdata.append("saleman", this.ruleForm.saleman);
      formdata.append("reportManId", this.ruleForm.reportManId);
      formdata.append("companyAddress", this.ruleForm.companyAddress);
      formdata.append("salemanId", this.ruleForm.salemanId);
      formdata.append("linkman", this.ruleForm.linkman);
      formdata.append("linkmanNum", this.ruleForm.linkmanNum);
      formdata.append("zz", this.ruleForm.zz);
      formdata.append("policymaker", this.ruleForm.policymaker);
      formdata.append("customerBelong", this.ruleForm.customerBelong);
      formdata.append("policymakerNum", this.ruleForm.policymakerNum);
      formdata.append("customerDemand", this.ruleForm.customerDemand);
      formdata.append("informationSources", this.ruleForm.informationSources);
      formdata.append("originalModel", this.ruleForm.originalModel);
      formdata.append("estimatedPurchaseTime", this.ruleForm.estimatedPurchaseTime);
      formdata.append("note", this.ruleForm.note);
      formdata.append("state", this.ruleForm.state);
      formdata.append("zzid", this.ruleForm.zzid);
      if (this.ruleForm.isorder == "1") {
        formdata.append("cdjx", this.ruleForm.cdjx);
      }
      if (this.ruleForm.state == "2") {
        formdata.append("isover", "1");
      }
      if (this.ruleForm.failReason && this.ruleForm.failReason == null) {
        this.ruleForm.failReason == "";
      }
      if (this.ruleForm.failReason && this.ruleForm.failReason != null) {
        formdata.append("failReason", this.ruleForm.failReason);
      }

      const result = await updateRe(formdata);
      if (result.code == 0) {
        this.$notify.success({
          title: this.$t('messages.success'),
          message: result.message
        });
        this.$router.back();
      } else {
        this.$notify.error({
          title: this.$t('messages.error'),
          message: result.message
        });
      }
    },

    both(a) {
      this.funnel.winPercent = a;
      if (
        this.funnel.budgetedAmount != "" &&
        this.funnel.budgetedAmount != null
      ) {
        this.funnel.expectedOutput =
          (parseInt(this.funnel.budgetedAmount) *
            parseInt(this.options6[+this.funnel.winPercent].text)) /
          100;
      }
    },
    both1(a) {
      this.funnel.currentStage = a;
      if (
        this.funnel.budgetedAmount != "" &&
        this.funnel.budgetedAmount != null
      ) {
        this.funnel.expectedOutput =
          (parseInt(this.funnel.budgetedAmount) *
            parseInt(this.options6[+this.funnel.winPercent].text)) /
          100;
      }
    },
    jisuan() {
      if (
        this.funnel.budgetedAmount != "" &&
        this.funnel.budgetedAmount != null
      ) {
        this.funnel.expectedOutput =
          (parseInt(this.funnel.budgetedAmount) *
            parseInt(this.options6[+this.funnel.winPercent].text)) /
          100;
      }
    },
    async sauFunnel() {
      const formdata = new FormData();
      if (this.funnel.id != "" && this.funnel.id != null) {
        formdata.append("id", this.funnel.id);
      }
      formdata.append(
        "industryClassification",
        this.funnel.industryClassification
      );
      formdata.append("businessType", this.funnel.businessType);
      formdata.append("projectname", this.funnel.projectname);
      formdata.append("customerUnit", this.funnel.customerUnit);
      formdata.append("salesman", this.funnel.salesman);
      formdata.append("salesmanId", this.funnel.salesmanId);
      if (this.funnel.startTime && typeof this.funnel.startTime === "string") {
        formdata.append("startTime", this.funnel.startTime);
      } else if (
        this.funnel.startTime &&
        this.funnel.startTime instanceof Date
      ) {
        formdata.append(
          "startTime",
          moment(+this.funnel.startTime).format("YYYY-MM-DD HH:mm:ss")
        );
      } else {
        formdata.append("startTime", this.funnel.startTime);
      }
      formdata.append("budgetedAmount", this.funnel.budgetedAmount);
      formdata.append("currentStage", this.funnel.currentStage);
      formdata.append("winPercent", this.funnel.winPercent);
      formdata.append(
        "customerLeadDepartment",
        this.funnel.customerLeadDepartment
      );
      formdata.append("expectedOutput", this.funnel.expectedOutput);
      formdata.append("contractAmount", this.funnel.contractAmount);
      formdata.append("relevantContact", this.funnel.relevantContact);
      formdata.append("customerStakeholders", this.funnel.customerStakeholders);
      formdata.append("keyman", this.funnel.keyman);
      formdata.append("demandContent", this.funnel.demandContent);
      formdata.append("currentProgress", this.funnel.currentProgress);
      if (
        this.funnel.nextVisitTime &&
        typeof this.funnel.nextVisitTime === "string"
      ) {
        formdata.append("nextVisitTime", this.funnel.nextVisitTime);
      } else if (
        this.funnel.nextVisitTime &&
        this.funnel.nextVisitTime instanceof Date
      ) {
        formdata.append(
          "nextVisitTime",
          moment(+this.funnel.nextVisitTime).format("YYYY-MM-DD HH:mm:ss")
        );
      } else {
        formdata.append("nextVisitTime", this.funnel.nextVisitTime);
      }
      formdata.append("visitContent", this.funnel.visitContent);
      formdata.append("competitor", this.funnel.competitor);
      formdata.append("cooperativePartner", this.funnel.cooperativePartner);
      formdata.append("determine", this.funnel.determine);
      formdata.append("failureReason", this.funnel.failureReason);
      formdata.append("recordId", this.ruleForm.associatedRecordsId);
      this.fileList1.map(file => {
        formdata.append("files", file);
      });
      formdata.append("delFileId", this.funnel.delFileId);
      const result = await SaUFunnel(formdata);
      if (result.code == 0) {
        this.$notify.success({
          title: this.$t('messages.success'),
          message: result.message
        });
        await this.gF();
        this.fileList1 = [];
      } else {
        this.$notify.error({
          title: this.$t('messages.error'),
          message: result.message
        });
      }
    },
    async handleExpand(row) {
      row.expanded = !row.expanded;
      if (row.description || !row.expanded) {
        return;
      }
      const result = await selectThisRecord(row.id);
      if (result && result.code == 0) {
        this.ruleForm1 = result.data;
        const a = this.ruleForm.ssq.split("/");

        if (a.length == "3") {
          this.ruleForm1.p = a[0];
          this.ruleForm1.c = a[1];
          this.ruleForm1.area = a[2];
        } else if (a.length == "4") {
          this.ruleForm1.p = a[0];
          this.ruleForm1.c = a[1];
          this.ruleForm1.area = a[2];
          this.ruleForm1.zhen = a[3];
        }
        if (this.ruleForm1.files && this.ruleForm1.files.length > 0) {
          this.ruleForm1.srcList = [];
          this.ruleForm1.files.forEach(e => {
            this.ruleForm1.srcList.push(e.path);
          });
        }
      }

      row.description = this.ruleForm1;
    },
    addFollow() {
      this.dialogFormVisible = true;
      this.follow.fillTime = +new Date();
      this.follow.saleman = this.ruleForm.saleman;
      this.follow.salemanId = this.ruleForm.salemanId;
      this.follow.trackSituation = "";
      this.follow.nextVisitTime = "";
      this.follow.nextVisitGoal = "";
      this.follow.recordId = this.ruleForm.associatedRecordsId;
      this.fileList2 = [];
    },
    async alAdd() {
      const formdata = new FormData();
      formdata.append("saleman", this.follow.saleman);
      formdata.append("salemanId", this.follow.salemanId);
      formdata.append("trackSituation", this.follow.trackSituation);
      formdata.append("nextVisitGoal", this.follow.nextVisitGoal);
      formdata.append("recordId", this.follow.recordId);
      formdata.append(
        "fillTime",
        moment(+this.follow.fillTime).format("YYYY-MM-DD HH:mm:ss")
      );
      formdata.append(
        "nextVisitTime",
        moment(+this.follow.nextVisitTime).format("YYYY-MM-DD HH:mm:ss")
      );

      this.fileList2.map(file => {
        formdata.append("files", file);
      });
      const result = await savefollow(formdata);
      if (result.code == 0) {
        this.$notify.success({
          title: this.$t('messages.success'),
          message: result.message
        });
        this.dialogFormVisible = false;
        await this.getAllFollow();
      } else {
        this.$notify.error({
          title: this.$t('messages.error'),
          message: result.message
        });
      }
    },
    async getAllFollow() {
      const result = await getfollow(this.ruleForm.associatedRecordsId);
      if (result.code == 0) {
        this.followArr = result.data;
      } else {
        this.$notify.error({
          title: this.$t('messages.error'),
          message: result.message
        });
      }
    },
    async baseaddCC() {
      const formdata = new FormData();
      if (
        this.ruleForm.company != "" &&
        this.ruleForm.company != null &&
        this.ruleForm.linkmanNum != "" &&
        this.ruleForm.linkmanNum != null &&
        this.ruleForm.policymakerNum != "" &&
        this.ruleForm.policymakerNum != null
      ) {
        formdata.append("id", this.ruleForm.associatedRecordsId);
        formdata.append("company", this.ruleForm.company);
        formdata.append("saleman", this.ruleForm.saleman);
        formdata.append("linkmanNum", this.ruleForm.linkmanNum);
        formdata.append("policymakerNum", this.ruleForm.policymakerNum);
        const result = await ChaChong(formdata);
        this.CCresult = result.data;
        if (this.CCresult == 1) {
          this.$message.success(result.message);
        } else if (this.CCresult == 2) {
          this.$message.info(result.message);
        } else if (!Array.isArray(this.CCresult)) {
          if ("ygkcus" in this.CCresult) {
            for (let i in this.CCresult["ygkcus"]) {
              this.CCresult["ygkcus"][i].salemandd = "";
              // if(Array.isArray(this.CCresult['ygkcus'][i].salesmen)){
              //   for(let item in this.CCresult['ygkcus'][i].salesmen){
              //     this.CCresult['ygkcus'][i].salemandd = this.CCresult['ygkcus'][i].salesmen[item]+ ' '
              //   }

              // }
              this.zsArray.push({
                reportTime: this.CCresult["ygkcus"][i].createdAt,
                company: this.CCresult["ygkcus"][i].company,
                saleman: this.CCresult["ygkcus"][i].salesmen
              });
            }
          } else {
          }
          if ("list204" in this.CCresult) {
            for (let ii in this.CCresult["list204"]) {
              this.zsArray.push(this.CCresult["list204"][ii]);
            }
          } else {
          }
          this.Ttitle = this.$t('messages.oldCustomerInfo');
          this.dialogTableVisible = true;
        } else if (Array.isArray(this.CCresult)) {
          this.zsArray = this.CCresult;
          this.Ttitle = this.$t('messages.reportedInfo');
          this.dialogTableVisible = true;
        }
      } else {
        this.$message.info(this.$t('messages.completeForm'));
      }
    },
    async jxAdd() {
      if (this.ruleForm.state == "2") {
        this.dialogTableVisible = false;
        this.dialogyc = true;
      } else {
        const formdata = new FormData();
        formdata.append(
          "reportTime",
          moment(+new Date()).format("YYYY-MM-DD HH:mm:ss")
        );
        formdata.append("reportMan", this.ruleForm.reportMan);
        formdata.append("saleman", this.ruleForm.saleman);
        formdata.append("company", this.ruleForm.company);
        formdata.append("reportManId", this.ruleForm.reportManId);
        formdata.append("salemanId", this.ruleForm.salemanId);
        formdata.append("ssq", this.ruleForm.ssq);
        formdata.append("zz", this.ruleForm.zz);
        formdata.append("companyAddress", this.ruleForm.companyAddress);
        formdata.append("linkman", this.ruleForm.linkman);
        formdata.append("linkmanNum", this.ruleForm.linkmanNum);
        formdata.append("policymaker", this.ruleForm.policymaker);
        formdata.append("customerBelong", this.ruleForm.customerBelong);
        formdata.append("policymakerNum", this.ruleForm.policymakerNum);
        formdata.append("customerDemand", this.ruleForm.customerDemand);
        formdata.append("informationSources", this.ruleForm.informationSources);
        formdata.append("originalModel", this.ruleForm.originalModel);

        if (
          this.ruleForm.estimatedPurchaseTime &&
          typeof this.ruleForm.estimatedPurchaseTime === "string"
        ) {
          formdata.append(
            "estimatedPurchaseTime",
            this.ruleForm.estimatedPurchaseTime
          );
        } else if (
          this.ruleForm.estimatedPurchaseTime &&
          this.ruleForm.estimatedPurchaseTime instanceof Date
        ) {
          formdata.append(
            "estimatedPurchaseTime",
            moment(+this.ruleForm.estimatedPurchaseTime).format(
              "YYYY-MM-DD HH:mm:ss"
            )
          );
        } else {
          formdata.append(
            "estimatedPurchaseTime",
            this.ruleForm.estimatedPurchaseTime
          );
        }
        formdata.append("isorder", this.ruleForm.isorder);
        formdata.append("isover", this.ruleForm.isover);
        formdata.append("note", this.ruleForm.note);
        formdata.append("zzid", this.ruleForm.zzid);
        formdata.append("cdjx", this.ruleForm.cdjx);
        formdata.append(
          "associatedRecordsId",
          this.ruleForm.associatedRecordsId
        );

        formdata.append("state", "1");
        formdata.append("oldFiles", this.srcList);
        this.fileList.map(file => {
          formdata.append("files", file);
        });
        const result = await ReAdd(formdata);
        if (result.code == 0) {
          this.$notify.success({
            title: this.$t('messages.success'),
            message: result.message
          });
          this.$router.back();
        } else {
          this.$notify.error({
            title: this.$t('messages.error'),
            message: result.message
          });
        }
      }
    },
    async endAdd() {
      if (this.ycyy == "") {
        this.$message.info(this.$t('recordDetail.delayReason'));
        return false;
      }
      const formdata = new FormData();
      formdata.append(
        "reportTime",
        moment(+new Date()).format("YYYY-MM-DD HH:mm:ss")
      );
      formdata.append("reportMan", this.ruleForm.reportMan);
      formdata.append("saleman", this.ruleForm.saleman);
      formdata.append("company", this.ruleForm.company);
      formdata.append("reportManId", this.ruleForm.reportManId);
      formdata.append("salemanId", this.ruleForm.salemanId);
      formdata.append("ssq", this.ruleForm.ssq);
      formdata.append("zz", this.ruleForm.zz);
      formdata.append("companyAddress", this.ruleForm.companyAddress);
      formdata.append("linkman", this.ruleForm.linkman);
      formdata.append("linkmanNum", this.ruleForm.linkmanNum);
      formdata.append("policymaker", this.ruleForm.policymaker);
      formdata.append("customerBelong", this.ruleForm.customerBelong);
      formdata.append("policymakerNum", this.ruleForm.policymakerNum);
      formdata.append("customerDemand", this.ruleForm.customerDemand);
      formdata.append("informationSources", this.ruleForm.informationSources);
      formdata.append("originalModel", this.ruleForm.originalModel);
      formdata.append("ycyy", this.ycyy);

      if (
        this.ruleForm.estimatedPurchaseTime &&
        typeof this.ruleForm.estimatedPurchaseTime === "string"
      ) {
        formdata.append(
          "estimatedPurchaseTime",
          this.ruleForm.estimatedPurchaseTime
        );
      } else if (
        this.ruleForm.estimatedPurchaseTime &&
        this.ruleForm.estimatedPurchaseTime instanceof Date
      ) {
        formdata.append(
          "estimatedPurchaseTime",
          moment(+this.ruleForm.estimatedPurchaseTime).format(
            "YYYY-MM-DD HH:mm:ss"
          )
        );
      } else {
        formdata.append(
          "estimatedPurchaseTime",
          this.ruleForm.estimatedPurchaseTime
        );
      }
      formdata.append("isorder", this.ruleForm.isorder);
      formdata.append("isover", this.ruleForm.isover);
      formdata.append("note", this.ruleForm.note);
      formdata.append("zzid", this.ruleForm.zzid);
      formdata.append("cdjx", this.ruleForm.cdjx);
      formdata.append("associatedRecordsId", this.ruleForm.associatedRecordsId);
      if (this.CCresult == "1") {
        formdata.append("state", this.ruleForm.state);
      } else {
        formdata.append("state", "1");
      }

      formdata.append("oldFiles", this.srcList);
      this.fileList.map(file => {
        formdata.append("files", file);
      });
      const result = await ReAdd(formdata);
      if (result.code == 0) {
        this.$notify.success({
          title: this.$t('messages.success'),
          message: result.message
        });
        this.$router.back();
      } else {
        this.$notify.error({
          title: this.$t('messages.error'),
          message: result.message
        });
      }
    },
    closeyc() {
      this.ycyy = "";
    }
  }
};
</script>
<template>
  <div class="customerDetails">
    <header>
      <h1>{{ $t('recordDetail.title') }}</h1>
      <a-space>
        <a-button
          @click="goBack()"
          style="color: rgb(33, 141, 235)"
          icon="rollback"
        >
          <span style="color: #000">{{ $t('buttons.goBack') }}</span>
        </a-button>
        <a-button
          :loading="isLoading"
          type="primary"
          @click="adminUp"
          v-if="authorities.find(a => a.code === 'crm:records:update')"
          >{{ $t('buttons.save') }}</a-button
        >
      </a-space>
    </header>
    <section class="userInfo">
      <div class="infoList">
        <div class="up">
          <div style="position: relative;">
            <a-form-model
              style="width: 100%; display: flex; justify-content: space-between; padding-right: 40px;"
              v-bind="{ labelCol: { span: 8 }, wrapperCol: { span: 16 } }"
              :rules="rules"
              :model="ruleForm"
              ref="ruleForm"
            >
              <div style="width: 24%">
                <a-form-model-item :label="$t('recordDetail.reportTime')" prop="type" v-show="youid==ruleForm.reportManId || authorities.find(a => a.code === 'crm:records:update')">
                  <el-date-picker
                    type="date"
                    :placeholder="$t('device.selectDate')"
                    v-model="ruleForm.reportTime"
                    :disabled="true"
                  ></el-date-picker>
                </a-form-model-item>
                <a-form-model-item :label="$t('recordDetail.reporter')" prop="reportMan">
                  <el-select
                    v-model="ruleForm.reportMan"
                    filterable
                    remote
                    reserve-keyword
                    :placeholder="$t('messages.peu')"
                    :remote-method="remoteMethod2"
                    :loading="loading"
                    style="width: 75%;"
                    :disabled="
                      !authorities.find(a => a.code === 'crm:records:update')
                    "
                  >
                    <el-option
                      v-for="item in reuserList"
                      :key="item.id"
                      :label="
                item.realName + '-' + item.organization + '-' + item.username
              "
                      :value="item.realName"
                      @click.native="clickThis2(item)"
                    >
                    </el-option>
                  </el-select>
                </a-form-model-item>
                <a-form-model-item :label="$t('recordDetail.reporterOrganization')" prop="zz">
                  <el-input v-model="ruleForm.zz" :disabled="true"></el-input>
                </a-form-model-item>
                <a-form-model-item :label="$t('common.salesMen')" prop="saleman">
                  <el-select
                    v-model="ruleForm.saleman"
                    filterable
                    remote
                    reserve-keyword
                    :placeholder="$t('messages.peu')"
                    :remote-method="remoteMethod1"
                    :loading="loading"
                    style="width: 75%;"
                    :disabled="
                      !authorities.find(a => a.code === 'crm:records:update')
                    "
                  >
                    <el-option
                      v-for="item in userList"
                      :key="item.id"
                      :label="
                item.realName + '-' + item.organization + '-' + item.username
              "
                      :value="item.realName"
                      @click.native="clickThis1(item)"
                    >
                    </el-option>
                  </el-select>
                </a-form-model-item>
                <a-form-model-item :label="$t('customer.company')" prop="company">
                  <el-select
                    v-model="ruleForm.company"
                    filterable
                    remote
                    reserve-keyword
                    :placeholder="$t('messages.company_empty')"
                    :remote-method="remoteMethod"
                    :loading="loading"
                    style="width: 65%;"
                    :disabled="
                      ruleForm.state == '2' &&
                        !authorities.find(a => a.code === 'crm:records:update')
                    "
                  >
                    <el-option
                      v-for="item in companyList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.name"
                      @click.native="clickThis"
                    >
                    </el-option>
                  </el-select>
                  <el-button @click="baseaddCC">{{ $t('recordDetail.duplicate') }}</el-button>
                </a-form-model-item>
                <a-form-model-item :label="$t('customer.address')" prop="companyAddress">
                  <el-input
                    v-model="ruleForm.companyAddress"
                    :disabled="
                      ruleForm.state == '2' &&
                        !authorities.find(a => a.code === 'crm:records:update')
                    "
                  ></el-input>
                </a-form-model-item>
              </div>
              <div style="width: 24%">
                <a-form-model-item :label="$t('orders.contactPerson')" prop="linkman">
                  <el-input
                    v-model="ruleForm.linkman"
                    :disabled="
                      ruleForm.state == '2' &&
                        !authorities.find(a => a.code === 'crm:records:update')
                    "
                  ></el-input>
                </a-form-model-item>
                <a-form-model-item :label="$t('device.mobile')" prop="linkmanNum">
                  <el-input
                    v-model="ruleForm.linkmanNum"
                    :disabled="
                      ruleForm.state == '2' &&
                        !authorities.find(a => a.code === 'crm:records:update')
                    "
                  ></el-input>
                </a-form-model-item>
                <a-form-model-item :label="$t('recordDetail.policymaker')" prop="policymaker">
                  <el-input
                    v-model="ruleForm.policymaker"
                    :disabled="
                      ruleForm.state == '2' &&
                        !authorities.find(a => a.code === 'crm:records:update')
                    "
                  ></el-input>
                </a-form-model-item>
                <a-form-model-item :label="$t('recordDetail.policymakerNum')" prop="policymakerNum">
                  <el-input
                    v-model="ruleForm.policymakerNum"
                    :disabled="
                      ruleForm.state == '2' &&
                        !authorities.find(a => a.code === 'crm:records:update')
                    "
                  ></el-input>
                </a-form-model-item>
                <a-form-model-item :label="$t('recordDetail.customerDemand')" prop="customerDemand">
                  <el-input
                    v-model="ruleForm.customerDemand"
                    :disabled="
                      ruleForm.state == '2' &&
                        !authorities.find(a => a.code === 'crm:records:update')
                    "
                  ></el-input>
                </a-form-model-item>
                <a-form-model-item :label="$t('recordDetail.originalModel')" prop="originalModel">
                  <el-input
                    v-model="ruleForm.originalModel"
                    :disabled="
                      ruleForm.state == '2' &&
                        !authorities.find(a => a.code === 'crm:records:update')
                    "
                  ></el-input>
                </a-form-model-item>
              </div>
              <div style="width: 24%">
                <a-form-model-item
                  :label="$t('recordDetail.customerBelong')"
                  prop="customerBelong"
                >
                  <el-input
                    v-model="ruleForm.customerBelong"
                    :disabled="

                        !authorities.find(a => a.code === 'crm:records:update')
                    "
                  ></el-input>
                </a-form-model-item>
                <a-form-model-item :label="$t('recordDetail.informationSources')">
                  <el-select
                    v-model="ruleForm.informationSources"
                    class="m-2"
                    :disabled="
                      ruleForm.state == '2' &&
                        !authorities.find(a => a.code === 'crm:records:update')
                    "
                  >
                    <el-option
                      v-for="item in options8"
                      :key="item.value"
                      :label="item.text"
                      :value="item.value"
                    />
                  </el-select>
                </a-form-model-item>
                <a-form-model-item
                  :label="$t('recordDetail.estimatedPurchaseTime')"
                  prop="estimatedPurchaseTime"
                >
                  <el-input
                    v-model="ruleForm.estimatedPurchaseTime"
                    :disabled="
                      ruleForm.state == '2' &&
                        !authorities.find(a => a.code === 'crm:records:update')
                    "
                  ></el-input>
                </a-form-model-item>
                <a-form-model-item :label="$t('common.remark')" prop="note">
                  <el-input type="textarea" v-model="ruleForm.note"></el-input>
                </a-form-model-item>
                <a-form-model-item :label="$t('recordDetail.isorder')" prop="isorder">
                  <el-select
                    v-model="ruleForm.isorder"
                    class="m-2"
                    :disabled="
                      !authorities.find(a => a.code === 'crm:records:update')
                    "
                  >
                    <el-option
                      v-for="item in options1"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </a-form-model-item>
                <a-form-model-item :label="$t('recordDetail.state')" prop="state">
                  <el-select
                    v-model="ruleForm.state"
                    class="m-2"
                    :disabled="
                      !authorities.find(a => a.code === 'crm:records:update')
                    "
                  >
                    <el-option
                      v-for="item in options2"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </a-form-model-item>
                <a-form-model-item
                  :label="$t('recordDetail.failReason')"
                  prop="failReason"
                  v-if="this.ruleForm.state == 3"
                >
                  <el-input
                    type="textarea"
                    v-model="ruleForm.failReason"
                    :disabled="
                      !authorities.find(a => a.code === 'crm:records:update')
                    "
                  ></el-input>
                </a-form-model-item>
                <a-form-model-item
                  :label="$t('recordDetail.cdjx')"
                  prop="cdjx"
                  v-if="this.ruleForm.isorder == 1"
                >
                  <el-input
                    type="textarea"
                    v-model="ruleForm.cdjx"
                    :disabled="
                      !authorities.find(a => a.code === 'crm:records:update')
                    "
                  ></el-input>
                </a-form-model-item>
                <a-form-model-item
                  :label="$t('recordDetail.ycyy')"
                  prop="ycyy"
                  v-if="this.ruleForm.ycyy != null && this.ruleForm.ycyy"
                >
                  <el-input
                    type="textarea"
                    v-model="ruleForm.ycyy"
                    :disabled="true"
                  ></el-input>
                </a-form-model-item>
              </div>
              <div style="width: 24%" class="nLabel">
                <a-form-model-item :label="$t('common.picture')">
                  <div
                    @mouseover="hm(a)"
                    @mouseleave="ml(a)"
                    style="display:inline-block;position:relative"
                    v-for="(a, i) in ruleForm.files"
                    :key="i"
                  >
                    <el-image
                      style="width: 100px; height: 100px; "
                      :src="a.path"
                      :preview-src-list="srcList"
                    >
                    </el-image>
                    <em class="close" :class="{ ds: a.show }" @click="delPic(i)"
                      >X</em
                    >
                  </div>

                  <div
                    class="upload"
                    v-show="
                      ruleForm.isover != '1' ||
                        authorities.find(a => a.code === 'crm:records:update')
                    "
                  >
                    <button
                      aria-disabled="false"
                      type="button"
                      class="el-button el-button"
                      :key="fileList.length"
                    >
                      <span
                        style="padding: 8px 15px;"
                        class=""
                        @click="showFileModal"
                        ><i class="el-icon-upload"></i
                        >&nbsp;&nbsp;{{ $t('buttons.uploadPic') }}</span
                      >
                    </button>
                    <input
                      ref="InputFileDOm"
                      class="file"
                      type="file"
                      :accept="'.mp4,.jpg,.jpeg,.png,.webm'"
                      :limit="6"
                      @change="hadnleFileCHnage($event, '0')"
                      multiple
                    />
                    <div class="upload-demo" data-v-1ab1ffd8="">
                      <ul
                        class="el-upload-list el-upload-list--text"
                        :key="fileList.length"
                      >
                        <li
                          tabindex="0"
                          class="el-upload-list__item is-success"
                          v-for="(file, index) in fileList"
                          :key="index"
                        >
                          <!----><a class="el-upload-list__item-name"
                            ><i class="el-icon-document"></i>{{ file.name }}</a
                          ><label class="el-upload-list__item-status-label"
                            ><i
                              class="el-icon-upload-success el-icon-circle-check"
                            ></i></label
                          ><i class="el-icon-close" @click="rF(index)"></i
                          ><i class="el-icon-close-tip">{{ $t('recordDetail.delete') }}</i>
                        </li>
                      </ul>
                    </div>
                  </div>
                </a-form-model-item>
              </div>
            </a-form-model>
            <a-form-model
              style="width: 100%; display: flex; justify-content: space-between; padding-right: 40px;"
              v-bind="{ labelCol: { span: 2 }, wrapperCol: { span: 22 } }"
              :rules="rules"
              :model="ruleForm"
              ref="ruleForm1"
              class="ssq"
            >
              <a-form-model-item style="width: 100%;" :label="$t('recordDetail.area')" prop="ssq">
                <el-select
                  v-model="p"
                  filterable
                  :placeholder="$t('recordDetail.province')"
                  @change="selectSheng"
                  style="width: 12%;"
                  :disabled="
                    ruleForm.state == '2' &&
                      !authorities.find(a => a.code === 'crm:records:update')
                  "
                >
                  <el-option
                    v-for="(item, index) in china"
                    :key="index"
                    :label="item.province"
                    :value="item.province"
                  >
                  </el-option>
                </el-select>

                <el-select
                  v-model="c"
                  filterable
                  :placeholder="$t('recordDetail.city')"
                  @change="selectCity"
                  style="width: 12%;"
                  :disabled="
                    ruleForm.state == '2' &&
                      !authorities.find(a => a.code === 'crm:records:update')
                  "
                >
                  <el-option
                    v-for="(item, index) in selectedProvince.citys"
                    :key="index"
                    :label="item.city"
                    :value="item.city"
                  >
                  </el-option>
                </el-select>

                <el-select
                  v-model="area"
                  filterable
                  :placeholder="$t('recordDetail.region')"
                  style="width: 12%;"
                  @change="selectArea"
                  :disabled="
                    ruleForm.state == '2' &&
                      !authorities.find(a => a.code === 'crm:records:update')
                  "
                >
                  <el-option
                    v-for="(item, index) in selectedCity.areas"
                    :key="index"
                    :label="item.area"
                    :value="item.area"
                  >
                  </el-option>
                </el-select>
                <el-select
                  v-model="zhen"
                  filterable
                  :placeholder="$t('recordDetail.town')"
                  style="width: 12%;"
                  v-if="area == '慈溪市'"
                  @change="selectzhen"
                  :disabled="
                    ruleForm.state == '2' &&
                      !authorities.find(a => a.code === 'crm:records:update')
                  "
                >
                  <el-option
                    v-for="(item, index) in cxzhen"
                    :key="index"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </a-form-model-item>
            </a-form-model>
          </div>

          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="allowAdd('ruleForm', 'ruleForm1')"
              >{{ $t('recordDetail.submit') }}</el-button
            >
          </div>
        </div>
      </div>
    </section>
    <div class="content">
      <a-card
        :border="false"
        :tab-list="tabList"
        :active-tab-key="tabKey"
        :scroll="{ y: 1000 }"
        @tabChange="key => onTabChange(key)"
      >
        <template v-if="tabKey === 'funnel'">
          <a-button
            type="primary"
            style="position: absolute; top: 12px; right: 20px;"
            @click="sauFunnel"
            >{{ $t('buttons.save') }}</a-button
          >
          <div style="position: relative;">
            <a-form-model
              style="width: 100%; display: flex; justify-content: space-between; padding-right: 40px;"
              v-bind="{ labelCol: { span: 6 }, wrapperCol: { span: 18 } }"
              :model="funnel"
            >
              <div style="width: 24%">
                <a-form-model-item
                  :label="$t('funnel.industryClassification')"
                  prop="industryClassification"
                >
                  <el-select
                    v-model="funnel.industryClassification"
                    class="m-2"
                  >
                    <el-option
                      v-for="item in options3"
                      :key="item.value"
                      :label="item.text"
                      :value="item.value"
                    />
                  </el-select>
                </a-form-model-item>
                <a-form-model-item :label="$t('funnel.businessType')" prop="businessType">
                  <el-select v-model="funnel.businessType" class="m-2">
                    <el-option
                      v-for="item in options4"
                      :key="item.value"
                      :label="item.text"
                      :value="item.value"
                    />
                  </el-select>
                </a-form-model-item>
                <a-form-model-item :label="$t('funnel.projectName')"  prop="projectname">
                  <el-input v-model="funnel.projectname"></el-input>
                </a-form-model-item>
                <a-form-model-item :label="$t('common.customerName')" prop="customerUnit">
                  <el-input v-model="funnel.customerUnit"></el-input>
                </a-form-model-item>
                <a-form-model-item :label="$t('common.salesMen')" prop="salesman">
                  <el-input v-model="funnel.salesman"></el-input>
                </a-form-model-item>
                <a-form-model-item :label="$t('funnel.startTime')" prop="startTime">
                  <el-date-picker
                    type="date"
                    :placeholder="$t('funnel.ss')"
                    v-model="funnel.startTime"
                  ></el-date-picker>
                </a-form-model-item>
                <a-form-model-item :label="$t('funnel.budgetedAmount')" prop="budgetedAmount">
                  <el-input
                    v-model="funnel.budgetedAmount"
                    @change="jisuan"
                  ></el-input>
                </a-form-model-item>
                <a-form-model-item :label="$t('funnel.currentStage')" prop="currentStage">
                  <el-select
                    v-model="funnel.currentStage"
                    class="m-2"
                    @change="both"
                  >
                    <el-option
                      v-for="item in options5"
                      :key="item.value"
                      :label="item.text"
                      :value="item.value"
                    />
                  </el-select>
                </a-form-model-item>
              </div>
              <div style="width: 24%">
                <a-form-model-item :label="$t('funnel.winPercent')" prop="winPercent">
                  <el-select
                    v-model="funnel.winPercent"
                    class="m-2"
                    @change="both1"
                  >
                    <el-option
                      v-for="item in options6"
                      :key="item.value"
                      :label="item.text"
                      :value="item.value"
                    />
                  </el-select>
                </a-form-model-item>
                <a-form-model-item :label="$t('funnel.expectedOutput')" prop="expectedOutput">
                  <el-input
                    v-model="funnel.expectedOutput"
                    :disabled="true"
                  ></el-input>
                </a-form-model-item>
                <a-form-model-item :label="$t('funnel.contractAmount')" prop="contractAmount">
                  <el-input v-model="funnel.contractAmount"></el-input>
                </a-form-model-item>
                <a-form-model-item
                  :label="$t('funnel.customerLeadDepartment')"
                  prop="customerLeadDepartment"
                >
                  <el-input v-model="funnel.customerLeadDepartment"></el-input>
                </a-form-model-item>
                <a-form-model-item :label="$t('funnel.relevantContact')" prop="relevantContact">
                  <el-input v-model="funnel.relevantContact"></el-input>
                </a-form-model-item>
                <a-form-model-item
                  :label="$t('funnel.customerStakeholders')"
                  prop="customerStakeholders"
                >
                  <el-input v-model="funnel.customerStakeholders"></el-input>
                </a-form-model-item>
                <a-form-model-item :label="$t('funnel.keyman')" prop="keyman">
                  <el-input v-model="funnel.keyman"></el-input>
                </a-form-model-item>
                <a-form-model-item :label="$t('funnel.demandContent')" prop="demandContent">
                  <el-input v-model="funnel.demandContent"></el-input>
                </a-form-model-item>
              </div>
              <div style="width: 24%">
                <a-form-model-item :label="$t('funnel.currentProgress')" prop="currentProgress">
                  <el-input v-model="funnel.currentProgress"></el-input>
                </a-form-model-item>
                <a-form-model-item
                  :label="$t('funnel.nextVisitTime')"
                  prop="nextVisitTime"
                >
                  <el-date-picker
                    type="date"
                    :placeholder="$t('funnel.ss')"
                    v-model="funnel.nextVisitTime"
                  ></el-date-picker>
                </a-form-model-item>
                <a-form-model-item :label="$t('funnel.visitContent')" prop="visitContent">
                  <el-input v-model="funnel.visitContent"></el-input>
                </a-form-model-item>
                <a-form-model-item :label="$t('funnel.competitor')" prop="competitor">
                  <el-input v-model="funnel.competitor"></el-input>
                </a-form-model-item>
                <a-form-model-item :label="$t('funnel.cooperativePartner')" prop="cooperativePartner">
                  <el-input v-model="funnel.cooperativePartner"></el-input>
                </a-form-model-item>
                <a-form-model-item :label="$t('funnel.determine')" prop="determine">
                  <el-select v-model="funnel.determine" class="m-2">
                    <el-option
                      v-for="item in options7"
                      :key="item.value"
                      :label="item.text"
                      :value="item.value"
                    />
                  </el-select>
                </a-form-model-item>
                <a-form-model-item :label="$t('funnel.failureReason')" prop="failureReason">
                  <el-input
                    type="textarea"
                    v-model="funnel.failureReason"
                  ></el-input>
                </a-form-model-item>
              </div>
              <div style="width: 24%" class="nLabel">
                <a-form-model-item :label="$t('common.picture')">
                  <div
                    @mouseover="hm(a)"
                    @mouseleave="ml(a)"
                    style="display:inline-block;position:relative"
                    v-for="(a, i) in funnel.files"
                    :key="i"
                  >
                    <el-image
                      style="width: 100px; height: 100px; "
                      :src="a.path"
                      :preview-src-list="srcList1"
                    >
                    </el-image>
                    <em
                      class="close"
                      :class="{ ds: a.show }"
                      @click="delPic1(i)"
                      >X</em
                    >
                  </div>

                  <div class="upload">
                    <button
                      aria-disabled="false"
                      type="button"
                      class="el-button el-button"
                      :key="fileList.length"
                    >
                      <span
                        style="padding: 8px 15px;"
                        class=""
                        @click="showFileModal1"
                        ><i class="el-icon-upload"></i
                        >&nbsp;&nbsp;{{ $t('buttons.uploadPic') }}</span
                      >
                    </button>
                    <input
                      ref="InputFileDOm1"
                      class="file"
                      type="file"
                      :accept="'.jpg,.jpeg,.png'"
                      :limit="6"
                      @change="hadnleFileCHnage1($event, '0')"
                      multiple
                    />
                    <div class="upload-demo" data-v-1ab1ffd8="">
                      <ul
                        class="el-upload-list el-upload-list--text"
                        :key="fileList1.length"
                      >
                        <li
                          tabindex="0"
                          class="el-upload-list__item is-success"
                          v-for="(file, index) in fileList1"
                          :key="index"
                        >
                          <!----><a class="el-upload-list__item-name"
                            ><i class="el-icon-document"></i>{{ file.name }}</a
                          ><label class="el-upload-list__item-status-label"
                            ><i
                              class="el-icon-upload-success el-icon-circle-check"
                            ></i></label
                          ><i class="el-icon-close" @click="rF1(index)"></i
                          ><i class="el-icon-close-tip">{{ $t('recordDetail.delete') }}</i>
                        </li>
                      </ul>
                    </div>
                  </div>
                </a-form-model-item>
              </div>
            </a-form-model>
          </div>
        </template>
        <template v-else-if="tabKey === 'uphistory'">
          <el-table
            :data="familyRecords"
            style="width: 100%"
            :header-cell-style="{ backgroundColor: '#fafafa' }"
            v-loading="isSystemLogLoading"
            @expand-change="handleExpand"
          >
            <el-table-column type="expand">
              <template slot-scope="props">
                <div style="padding: 0 50px">
                  <a-spin v-show="!props.row.description"></a-spin>
                  <div
                    v-show="props.row.description"
                    class="system_log_description"
                  >
                    <h3 style="margin-bottom: 15px">{{ $t('common.details') }}</h3>
                    <a-row style="margin-bottom: 15px">
                      <a-col :span="6">
                        <p>
                          {{ $t('recordDetail.reportTime') }}: {{
                            props.row.description.reportTime
                              ? props.row.description.reportTime
                              : ""
                          }}
                        </p>
                        <p>
                          {{ $t('recordDetail.reporter') }}: {{ props.row.description.reportMan || "" }}
                        </p>
                        <p>{{ $t('common.salesMen') }}: {{ props.row.description.saleman || "" }}</p>
                        <p>
                          {{ $t('customer.company') }}: {{ props.row.description.company || "" }}
                        </p>
                        <p>{{ $t('customer.area') }}: {{ props.row.description.ssq || "" }}</p>
                      </a-col>
                      <a-col :span="6">
                        <p>
                          {{ $t('customer.address') }}: {{
                            props.row.description.companyAddress || ""
                          }}
                        </p>
                        <p>{{ $t('orders.contactPerson') }}: {{ props.row.description.linkman || "" }}</p>
                        <p>
                          {{ $t('device.mobile') }}: {{
                            props.row.description.linkmanNum || ""
                          }}
                        </p>
                        <p>
                          {{ $t('recordDetail.policymaker') }}: {{ props.row.description.policymaker || "" }}
                        </p>
                        <p>
                          {{ $t('recordDetail.policymakerNum') }}: {{
                            props.row.description.policymakerNum || ""
                          }}
                        </p>
                      </a-col>
                      <a-col :span="6">
                        <p>
                          {{ $t('recordDetail.customerDemand') }}: {{
                            props.row.description.customerDemand || ""
                          }}
                        </p>
                        <p>
                          {{ $t('recordDetail.originalModel') }}: {{
                            props.row.description.originalModel || ""
                          }}
                        </p>
                        <p>
                          {{ $t('recordDetail.estimatedPurchaseTime') }}: {{
                            props.row.description.estimatedPurchaseTime || ""
                          }}
                        </p>
                        <p>
                          {{ $t('recordDetail.state') }}: {{ props.row.description.is || "" }}
                        </p>
                        <p>
                          {{ $t('recordDetail.failReason') }}: {{ props.row.description.failReason || "" }}
                        </p>
                      </a-col>
                      <a-col :span="6">
                        <p>{{ $t('recordDetail.ycyy') }}: {{ props.row.description.ycyy || "" }}</p>
                        <p>{{ $t('common.remark') }}: {{ props.row.description.note || "" }}</p>
                        {{ $t('common.picture') }}: 
                        <div
                          style="display:inline-block;position:relative"
                          v-for="(a, i) in props.row.description.srcList"
                          :key="i"
                        >
                          <el-image
                            style="width: 100px; height: 100px; "
                            :src="a"
                            :preview-src-list="props.row.description.srcList"
                          >
                          </el-image>
                        </div>
                      </a-col>
                    </a-row>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('recordDetail.reportTime')" prop="reportTime">
            </el-table-column>
            <el-table-column :label="$t('recordDetail.reporter')" prop="reportMan"> </el-table-column>
            <el-table-column :label="$t('common.salesMen')" prop="saleman"> </el-table-column>
            <el-table-column :label="$t('customer.company')" prop="company"> </el-table-column>
            <el-table-column :label="$t('recordDetail.reportRecord')" prop="is"> </el-table-column>
          </el-table>
        </template>
        <template v-else-if="tabKey === 'gzRecord'">
          <a-button
            type="primary"
            style="position: absolute; top: 12px; right: 20px;"
            @click="addFollow"
            >{{ $t('recordDetail.addFollowRecord') }}</a-button
          >
          <div v-for="(item, index) in followArr" :key="index">
            <div style="font-size:16px">
              <i class="el-icon-user"></i>{{ item.saleman }} &nbsp; &nbsp;
              &nbsp; &nbsp; &nbsp;<i class="el-icon-timer"></i
              >{{ item.fillTime }}
            </div>
            <div style="font-size:18px">{{ item.trackSituation }}</div>
            <div>
              <div
                style="display:inline-block;position:relative"
                v-for="(a, i) in item.files"
                :key="i"
              >
                <el-image
                  style="width: 100px; height: 100px; "
                  :src="a.path"
                  :preview-src-list="[a.path]"
                >
                </el-image>
              </div>
            </div>
            <div style="font-size:16px">
              {{ $t('recordDetail.nextVisitTime') }}: {{ item.nextVisitTime }}&nbsp; &nbsp; &nbsp;
              {{ $t('recordDetail.nextVisitGoal') }}: {{ item.nextVisitGoal }}
            </div>
            <br />
          </div>
        </template>
      </a-card>
      <el-dialog :title="$t('recordDetail.followRecord')" :visible.sync="dialogFormVisible">
        <el-form :model="follow">
          <el-form-item :label="$t('recordDetail.writeTime')" :label-width="'150px'">
            <el-date-picker
              type="date"
              :placeholder="$t('device.selectDate')"
              v-model="follow.fillTime"
              :disabled="true"
            ></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('common.salesMen')" :label-width="'150px'">
            <el-input
              v-model="follow.saleman"
              autocomplete="off"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('recordDetail.trackSituation')" required :label-width="'150px'">
            <el-input
              v-model="follow.trackSituation"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('funnel.nextVisitTime')" :label-width="'150px'">
            <el-date-picker
              type="date"
              :placeholder="$t('device.selectDate')"
              v-model="follow.nextVisitTime"
            ></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('recordDetail.nextVisitGoal')" :label-width="'150px'">
            <el-input
              v-model="follow.nextVisitGoal"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('common.picture')" :label-width="'150px'">
            <div class="upload">
              <button
                aria-disabled="false"
                type="button"
                class="el-button el-button"
                :key="fileList.length"
              >
                <span
                  style="padding: 8px 15px;"
                  class=""
                  @click="showFileModal2"
                  ><i class="el-icon-upload"></i>&nbsp;&nbsp;{{ $t('buttons.uploadPic') }}</span
                >
              </button>
              <input
                ref="InputFileDOm2"
                class="file"
                type="file"
                :accept="'.jpg,.jpeg,.png'"
                :limit="6"
                @change="hadnleFileCHnage2($event, '0')"
                multiple
              />
              <div class="upload-demo" data-v-1ab1ffd8="">
                <ul
                  class="el-upload-list el-upload-list--text"
                  :key="fileList2.length"
                >
                  <li
                    tabindex="0"
                    class="el-upload-list__item is-success"
                    v-for="(file, index) in fileList2"
                    :key="index"
                  >
                    <!----><a class="el-upload-list__item-name"
                      ><i class="el-icon-document"></i>{{ file.name }}</a
                    ><label class="el-upload-list__item-status-label"
                      ><i
                        class="el-icon-upload-success el-icon-circle-check"
                      ></i></label
                    ><i class="el-icon-close" @click="rF2(index)"></i
                    ><i class="el-icon-close-tip">{{ $t('recordDetail.delete') }}</i>
                  </li>
                </ul>
              </div>
            </div>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">{{ $t('common.cancelText') }}</el-button>
          <el-button type="primary" @click="alAdd">{{ $t('common.okText') }}</el-button>
        </div>
      </el-dialog>
      <el-dialog
        :title="Ttitle"
        :visible.sync="dialogTableVisible"
        @close="closeTable"
        :close-on-click-modal="false"
      >
        <el-table :data="zsArray">
          <!-- <el-table-column
            property="reportTime"
            label="日期"
            width="150"
          ></el-table-column> -->
          <el-table-column
            property="company"
            :label="$t('customer.company')"
            width="200"
          ></el-table-column>
          <el-table-column property="saleman" :label="$t('common.salesMen')" width="200">
            <template slot-scope="scope">
              <div v-if="Array.isArray(scope.row.saleman)">
                <p v-for="(item, index) in scope.row.saleman" :key="index">
                  {{ item }}
                </p>
              </div>
              <div v-else>{{ scope.row.saleman }}</div>
            </template>
          </el-table-column>
          <el-table-column property="state" :label="$t('recordDetail.state')" width="170">
            <template slot-scope="scope">
              <div v-if="scope.row.state == '1'">
                {{ $t('report46.unaudited') }}
              </div>
              <div v-else-if="scope.row.state == '2'">{{ $t('recordDetail.reportValid') }}</div>
              <div v-else-if="scope.row.state == '3'">{{ $t('recordDetail.reportInvalid') }}</div>
              <div v-else></div>
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogTableVisible = false">{{ $t('common.cancelText') }}</el-button>
          <el-button type="primary" @click="jxAdd" v-if="allowTJ"
            >{{ $t('buttons.submit') }}</el-button
          >
        </div>
      </el-dialog>
      <el-dialog
        :visible.sync="dialogyc"
        :title="$t('recordDetail.ycyy')"
        :close-on-click-modal="false"
        @close="closeyc"
      >
        <el-input v-model="ycyy" autocomplete="off"></el-input>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="endAdd">{{ $t('common.okText') }}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<style lang="less" scoped>
.customerDetails {
  position: relative;
  height: 100%;

  header {
    width: 100%;
    height: 55px;
    line-height: 55px;
    padding: 0 24px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;

    h1 {
      font-size: 18px;
      font-weight: 600;
    }
  }
}

.userInfo {
  width: 100%;
  height: auto;
  padding-left: 24px;
  display: flex;
  align-items: center;

  .infoList {
    height: 100%;
    flex: 1;
    display: flex;
    justify-content: space-around;
    margin-left: 30px;
    font-size: 15px;
    padding: 10px;

    .up {
      width: 100%;
    }
    .down {
      display: flex;
      flex-direction: column;
      padding-right: 50px;
      white-space: nowrap;

      .input-wrapper {
        display: flex;
        margin: 10px 0;

        .ant-input {
          width: 500px;
        }

        label {
          width: 80px;
          line-height: 32px;
        }
      }
    }

    ul {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }
}

.content {
  width: 100%;
  min-height: calc(100% - 280px);
  height: auto;
  background-color: #f5f4f7;
  padding: 10px;

  .ant-card {
    height: 100%;
  }

  h1 {
    font-size: 18px;
    font-weight: 600;
  }
}

/deep/ .ant-card-body {
  width: 100%;
  height: calc(100% - 55px);
  padding-bottom: 0;
}

.userList {
  width: 100%;
  height: 100%;
  padding: 0 10px;
  display: flex;
  justify-content: space-between;
  position: relative;

  .wrapper {
    width: 19%;
    height: 100%;
    border: 1px solid #ccc;
    overflow: auto;
    padding: 0 20px 10px;

    h2 {
      height: 50px;
      line-height: 50px;
      margin: 0;
      font-size: 18px;
    }
  }
}

.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.list-group {
  min-height: 20px;
  margin-bottom: 0;
  position: relative;
}

.list-group-item {
  cursor: move;
  position: relative;
}

.list-group-item i {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}

.col-md-3 {
  border: 1px solid #ccc;
}

.spin {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 10px;
}

.inputSelect {
  position: relative;

  .companyList {
    position: absolute;
    background-color: #fff;
    top: calc(100% + 5px);
    right: 0;
    left: 0;
    z-index: 100;
    border-radius: 5px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
    padding: 3px 0;
    min-height: 30px;
    max-height: 500px;
    overflow: auto;

    .spin {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    li {
      height: 30px;
      line-height: 30px;
      padding: 0 10px;
      cursor: pointer;
      font-size: 14px;
      color: #777;

      &.selected {
        background-color: #e6f7ff;
      }
    }
  }
}

.ant-table-column-title div {
  position: relative;
}

.ant-table-column-title span {
  position: relative;
}

.ant-table-column-title .anticon-caret-up {
  position: absolute;
  top: -1px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}

.ant-table-column-title span.ASC .anticon-caret-up {
  color: #1890ff;
}

.ant-table-column-title span.icons {
  position: absolute;
  right: 18px;
}

.ant-table-column-title span.DESC .anticon-caret-down {
  color: #1890ff;
}

.ant-table-column-title .anticon-caret-down {
  position: absolute;
  top: 8px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}

.deviceModal {
  width: 100%;
  min-height: calc(100% - 55px);
  position: relative;
}

/deep/ .ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  padding: 8px 16px !important;
}

.input-wrapper label {
  margin-right: 10px;

  &::before {
    display: inline-block;
    margin-right: 4px;
    color: #f5222d;
    font-size: 14px;
    font-family: SimSun, sans-serif;
    line-height: 1;
    content: "*";
  }
}

// .description, .userInfo {
//   display: flex;
//   width: 100%;
//   justify-content: space-between;
// }
// .userInfo {
//   padding: 0;
// }
.system_log_description {
  p {
    span {
      margin: 15px;

      &:first-child {
        margin-left: 0;
      }
    }
  }
}
.layout-container-demo .el-main {
  padding: 0;
}

.layout-container-demo .toolbar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  right: 20px;
}

:deep(.el-icon svg) {
  color: inherit !important;
}

input.file {
  display: none;
}

.dotClass {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: block;
  margin-left: 10px;
}
/deep/ .ant-form.ssq .ant-form-item .ant-form-item-label {
  width: 6%;
}
.close {
  position: absolute;
  width: 20px;
  height: 20px;
  text-align: center;
  border-radius: 50%;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(255, 255, 255, 0.6);
  font-size: 12px;
  top: 0;
  right: 0;
  font-style: normal;
  opacity: 0;
  cursor: pointer;
}
.close.ds {
  opacity: 1;
}
</style>
